import { render, staticRenderFns } from "./borrowerform.vue?vue&type=template&id=b92c218a&"
import script from "./borrowerform.vue?vue&type=script&lang=js&"
export * from "./borrowerform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports